/*
 * Marketfit · Título dinámico según variante
 *
 * 1) Cuando un producto tiene una opción cuyos valores solo difieren en una
 *    cantidad + unidad (p.ej. "Creatina UN 150g" / "250g" / "500g"), y esa
 *    misma cantidad aparece escrita en el título del producto (H1) y en el
 *    breadcrumb, mantiene ese número sincronizado con lo que el cliente elige.
 *
 * 2) Cuando el título termina en "+ Regalo(s)" y el producto tiene una
 *    opción de Regalo con un valor "Sin regalo" / "Sin regalos", oculta ese
 *    sufijo del título mientras esa opción esté seleccionada (para no
 *    prometer un regalo que no se va a entregar), y lo restaura si el
 *    cliente vuelve a elegir un regalo real.
 *
 * Ambos casos son no-op si el patrón no aplica al producto — seguro de
 * incluir en todas las páginas de producto sin revisar caso por caso.
 * No requiere cambios en Liquid más allá de incluir este archivo: lee los
 * valores directamente del selector de variantes ya renderizado en pantalla.
 */
(function () {
  function extractToken(str) {
    if (!str) return null;
    var m = String(str).match(/(\d+(?:[.,]\d+)?\s?(?:kg|gr|g|ml|lb|l))\b(?!.*\d)/i);
    return m ? m[1].replace(/\s+/g, ' ').trim() : null;
  }

  var NO_GIFT_PATTERN = /^sin\s+regalos?$/i;
  var GIFT_SUFFIX_PATTERN = /\s*\+\s*regalos?\s*$/i;

  function findSizeOption(productInfo) {
    var fieldsets = productInfo.querySelectorAll('.product-form__input--variant-picker');
    for (var i = 0; i < fieldsets.length; i++) {
      var fieldset = fieldsets[i];
      var radios = fieldset.querySelectorAll('input[type="radio"]');
      var values, getCurrentValue;

      if (radios.length) {
        values = Array.prototype.map.call(radios, function (el) { return el.value; });
        getCurrentValue = function () {
          var checked = fieldset.querySelector('input[type="radio"]:checked');
          return checked ? checked.value : null;
        };
      } else {
        var select = fieldset.querySelector('select');
        if (!select || !select.options.length) continue;
        values = Array.prototype.map.call(select.options, function (o) { return o.value; });
        getCurrentValue = function () { return select.value; };
      }

      if (values.length < 2) continue;

      var tokens = values.map(extractToken);
      if (tokens.indexOf(null) !== -1) continue;

      var prefixes = values.map(function (v, idx) { return v.replace(tokens[idx], '').trim(); });
      var samePrefix = prefixes.every(function (p) { return p === prefixes[0]; });
      var uniqueTokenCount = tokens.filter(function (t, idx) { return tokens.indexOf(t) === idx; }).length;

      if (!samePrefix || uniqueTokenCount < 2) continue;

      return { getCurrentToken: function () { return extractToken(getCurrentValue()); } };
    }
    return null;
  }

  function findGiftValue(productInfo) {
    var fieldsets = productInfo.querySelectorAll('.product-form__input--variant-picker');
    for (var i = 0; i < fieldsets.length; i++) {
      var fieldset = fieldsets[i];
      var label = fieldset.querySelector('.product-form__input__form-label');
      var labelText = label ? label.textContent.trim().toLowerCase() : '';
      if (labelText.indexOf('regalo') !== 0) continue;

      var checkedRadio = fieldset.querySelector('input[type="radio"]:checked');
      if (checkedRadio) return checkedRadio.value;

      var select = fieldset.querySelector('select');
      if (select) return select.value;
    }
    return null;
  }

  function initTitleSync(productInfo) {
    if (productInfo.dataset.mfTitleSync) return;
    productInfo.dataset.mfTitleSync = 'true';

    var titleEl = productInfo.querySelector('.product__title h1');
    var crumbEl = document.querySelector('.breadcrumb__list li:last-child');
    if (!titleEl) return;

    var sizeState = null;
    var sizeOption = findSizeOption(productInfo);
    if (sizeOption) {
      var initialToken = sizeOption.getCurrentToken();
      if (initialToken && titleEl.textContent.indexOf(initialToken) !== -1) {
        sizeState = { token: initialToken };
      }
    }

    var giftSuffixState = null;
    var giftMatch = titleEl.textContent.match(GIFT_SUFFIX_PATTERN);
    if (giftMatch) {
      giftSuffixState = { suffix: giftMatch[0], visible: true };
    }

    if (!sizeState && !giftSuffixState) return;

    productInfo.addEventListener('change', function () {
      setTimeout(function () {
        if (sizeState) {
          var freshSizeOption = findSizeOption(productInfo);
          if (freshSizeOption) {
            var newToken = freshSizeOption.getCurrentToken();
            if (newToken && newToken !== sizeState.token) {
              [titleEl, crumbEl].forEach(function (el) {
                if (el && el.textContent.indexOf(sizeState.token) !== -1) {
                  el.textContent = el.textContent.replace(sizeState.token, newToken);
                }
              });
              sizeState.token = newToken;
            }
          }
        }

        if (giftSuffixState) {
          var giftValue = findGiftValue(productInfo);
          var shouldShow = !(giftValue && NO_GIFT_PATTERN.test(giftValue.trim()));
          if (shouldShow !== giftSuffixState.visible) {
            [titleEl, crumbEl].forEach(function (el) {
              if (!el) return;
              if (shouldShow) {
                el.textContent = el.textContent + giftSuffixState.suffix;
              } else {
                el.textContent = el.textContent.replace(GIFT_SUFFIX_PATTERN, '');
              }
            });
            giftSuffixState.visible = shouldShow;
          }
        }
      }, 0);
    });
  }

  function initAll() {
    document.querySelectorAll('product-info').forEach(initTitleSync);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
